<div class="d-flex">
<span class="message__icon d-flex mr-2"><mat-icon>{{ data.type.icon }}</mat-icon></span>
<span class="message__text d-flex">{{ data.message }}</span>
</div>


